import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import auth from './auth';

ReactDOM.render(<App />, document.getElementById('root')); // eslint-disable-line react/jsx-filename-extension
registerServiceWorker();
auth.initializeAuth();



// WEBPACK FOOTER //
// ./src/index.js